import { getChartLabel } from "./chartLabel";
import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList
} from "recharts";
import { Form } from "react-bootstrap";
import CustomLegend from "./CustomLegend";
import CustomTooltip from "./CustomTooltip";

const Evths7 = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);

  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: "place", // default sort by place
    direction: "asc",
  });

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }

  const pwartnewData = data.map((item) => ({
    place: item.Place,
    PW_ART_NEW: Number(item.PPW_linked_with_ART_Vs_PW_reactive_Newly_detected),
  }));

  // Sorting logic
  const sortedData = [...pwartnewData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  // Handle sorting click
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      } else {
        return { key, direction: "asc" };
      }
    });
  };

  // Icon display function
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "⬍"; // default icon
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  return (
    <div style={{ width: "100%", position: "relative" }}>
      {/* Toggle Switch */}
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle">
              <h5> PPW linked with ART Vs PW reactive Newly detected {getChartLabel(filters, selectedState)}</h5>
            </div>

            <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>

      {showTable ? (
        // Table View
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead className="thead-light">
                <tr>
                  <th>Place</th>
                  <th
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => handleSort("PW_ART_NEW")}
                  >
                    PPW linked with ART Vs Newly detected  {getSortIcon("PW_ART_NEW")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td style={{ fontWeight: "bold" }}>{item.place}</td>
                    <td>{item.PW_ART_NEW}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        // Chart View
        <div className="card hptCard mt-4 border-0">
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              width={500}
              height={400}
              data={pwartnewData}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 130,
              }}
            >
              <XAxis
                dataKey="place"
                angle={-90}
                textAnchor="end"
                interval={0}
              />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Legend
                verticalAlign="top"
                content={<CustomLegend order={["PW_ART_NEW"]} />}
              />
              <Bar dataKey="PW_ART_NEW" fill="#ca8282ff" >
                <LabelList dataKey="PW_ART_NEW" position="top" />
                              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default Evths7;

